module.exports = __webpack_public_path__ + "img/asus-zephirus.388b0e95.jpg";